// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://xrruijuepuglkguryzlp.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhycnVpanVlcHVnbGtndXJ5emxwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDAxNDQzODEsImV4cCI6MjA1NTcyMDM4MX0.PUWEbh_k3JFmggdrvWHjYsN2AHQr3uX3-5VhMNInTSw";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);